import React from 'react';
import { EMPLOYEE_ATTENDANCE_EDIT } from 'src/constants/EndpointUrls';
import { SearchReactSelect, ConfirmedOptionRenderer } from 'src/components';
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import TargetDetailPeriod from './TargetDetailPeriod';
import styles from './AllAttendances.scss';

const redirectToPayDetail = atdId => redirectTo(concatParamsToUrl(EMPLOYEE_ATTENDANCE_EDIT, { id: atdId }));

const AllAttendances = props => {
  const { allAttendances = [], employeeAttendanceId, attendanceStartDate, attendanceEndDate, paymentDate } = props;

  return (
    <React.Fragment>
      <div className={styles.center}>
        <SearchReactSelect
          value={employeeAttendanceId}
          options={allAttendances}
          onChange={attendance => redirectToPayDetail(attendance.value)}
          width={350}
          size="large"
          cache={false}
          optionRenderer={option => <ConfirmedOptionRenderer option={option} />}
        />
      </div>
      <TargetDetailPeriod {...{ attendanceStartDate, attendanceEndDate, paymentDate }} />
    </React.Fragment>
  );
};

export default AllAttendances;
